import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const QR = () => {
  const { id } = useParams();

  useEffect(() => {}, []);
  return (
    <>
      <img src={`${import.meta.env.VITE_API_ENDPOINT}/api/company/${id}/qr`} />
    </>
  );
};

export default QR;
